<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('profile.label.id.document.upload')"
                         :parentScreen="parentScreen">

    <template v-for="(v, index) in $v.fileListUpload.$each.$iter">
      <div class="form-group row" :key="index">
        <label v-if="parseInt(index) === 0" class="control-label col-md-3 col-form-label">{{ $t('profile.label.id.document.upload.title') }}</label>
          <div :class="['col-md-6', { 'offset-md-3': parseInt(index) !== 0 }]">
            <FileInput v-model="v.fileUpload.$model" :name="'fileUpload' + index"
                       @onChangeFileInput="handleChangeFileInput">
            </FileInput>
            <error-messages-block :field="v.fileUpload">
              <template #fileTypeValidation>
                {{ $t('profile.error.file_type', {param1: fileTypeExtension}) }}
              </template>
              <template #fileSizeValidation>
                {{ $t('profile.error.file_size') }}
              </template>
              <template #fileNameValidation>
                {{$t('profile.error.file_duplicate')}}
              </template>
            </error-messages-block>
          </div>
      </div>
    </template>
    <div v-if="!isAddHidden" class="form-group row justify-content-center">
      <img src="@/assets/img/circle-plus.png" @click="addFiles()" style="cursor: pointer;"/>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit && isInvalidFile"
                @click="uploadFile"
                type="button"
        >
          {{ $t('profile.button.mn') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInputAndFiles">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import preparedDataInput from '@/common/mixins/preparedDataInput'
import $ from "jquery";
import {isNil} from "lodash";
import {
  fileCustomerNameDuplicateValidationForArr,
  fileSizeValidation,
  fileTypeValidationForArr
} from "@/common/helpers/validation";
import {createNamespacedHelpers} from "vuex";
import IConstants from "@/common/constants/IConstants";
const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");

export default {
  name: "UploadIdDocument",
  props: {
    blockInfo: {
      type: String
    }
  },
  data() {
    return {
      fileListUpload: this.initFileListUpload(),
      isAddHidden: false
    }
  },
  mixins: [formMixin, preparedDataInput, forceNewUtil],
  validations() {
    const self = this;

    const fileValidator = {
      fileTypeValidation: fileTypeValidationForArr(self),
      fileSizeValidation,
      fileNameValidation: fileCustomerNameDuplicateValidationForArr(self['fileListUpload'])
    };

    return {
      fileListUpload: {
        $each: {
          fileUpload: {
            ...fileValidator
          }
        }
      }
    }
  },

  computed: {
    isCorporation() {
      return this.$store.state[this.namespace].isCorporation
    },
    isInvalidFile(){
      const {$v} = this;
      let isFileEmpty = true;

      this.fileListUpload.forEach(file => {
        if(file.fileUpload != null) {
          isFileEmpty = false;
        }
      })

      return $v.$anyError || isFileEmpty;
    },
    fileUploadExt() {
      return this.$store.state.header.headerInfo.fileUploadExt
    },
    fileTypeExtension() {
      return this.fileUploadExt.toUpperCase();
    },
    ...mapForceNewsGetters(['mapGroupFieldAmsCustomer']),

    errorMessageMap() {
      return {
        'MSG_TRS_NAF_0088': this.$t('MSG_TRS_NAF_0088'),
        'MSG_TRS_NAF_0086': this.$t('MSG_TRS_NAF_0086', { param1: this.fileTypeExtension }),
        'MSG_TRS_NAF_0071': this.$t('MSG_TRS_NAF_0071'),
        'profile.label.upload.mynumber.msg.fail': this.$t('profile.label.upload.mynumber.msg.fail'),
      };
    }

  },
  methods: {
    initFileListUpload() {
      return [{fileUpload: null}, {fileUpload: null}]
    },

    addFiles() {
      for (let i = 0; i < 3; i++) {
        this.fileListUpload.push({ fileUpload: null });
      }
      this.isAddHidden = true;
    },

    reverseInputAndFiles() {
      this.reverseInput();
      this.fileListUpload = this.initFileListUpload();
      this.isAddHidden = false;
    },

    async uploadFile() {
      $("html, body").animate({scrollTop: 0}, "slow");

      let countNil = 0;
      for (let i = 0; i < IConstants.MAX_FILE_UPLOAD.UPLOAD_ID_DOCUMENT; i++) {
        const file = this.fileListUpload[i]?.['fileUpload'];

        if ((isNil(file))) {
          countNil++;
        }
      }

      if (countNil === IConstants.MAX_FILE_UPLOAD.UPLOAD_ID_DOCUMENT) {
        this.$emit('UploadIdDocumentInputEmpty');
        return;
      }

      this.changeBlockInfo = this.blockInfo
      let self = this;

      await this.$service.getService('profile').uploadIdDocumentFile(this.preparedDataInput(self))
          .then(response => {
            const errMsg = self.errorMessageMap[response.data.errorMessage];
            if (errMsg) {
              self.$parent.$emit('onMessage', errMsg, self.IConstants.API_MESSAGE_TYPE.ERROR);
            }

            if(response.data.isAxiosError) {
              self.$parent.$emit('onMessage', self.$t('profile.label.upload.mynumber.msg.fail'), self.IConstants.API_MESSAGE_TYPE.ERROR);
            }

            if (response.data.successMessage) {
              self.$parent.$emit('onMessage', self.$t('MSG_TRS_NAF_0214'), self.IConstants.API_MESSAGE_TYPE.SUCCESS);
            }
          }).catch(() => {
            self.$parent.$emit('onMessage', 'error.happen', self.IConstants.API_MESSAGE_TYPE.ERROR);
          }).finally(() => {
            self.reverseInputAndFiles();
          })
    },
  }
}
</script>

<style scoped>

</style>
